import { render } from "./Index.vue?vue&type=template&id=442c98d2"
import script from "./Index.vue?vue&type=script&lang=js"
export * from "./Index.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"components/Auth/Login/SocialCallback/Index.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "442c98d2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('442c98d2', __exports__)) {
    api.reload('442c98d2', __exports__)
  }
  
  module.hot.accept("./Index.vue?vue&type=template&id=442c98d2", () => {
    api.rerender('442c98d2', render)
  })

}


export default __exports__